import { Blocks, HandMetal, Sparkles, HeartHandshake, MapPin } from "lucide-react";

const ITEMS = [
  { icon: Blocks, title: "Ages 3–16", sub: "Programs for different learning stages", bg: "#EAF7FB", color: "#123B6D" },
  { icon: HandMetal, title: "Hands-On Learning", sub: "Build real-world skills", bg: "#F0FAEB", color: "#4C9A2A" },
  { icon: Sparkles, title: "Confidence & Creativity", sub: "More than just classes", bg: "#FFF6E5", color: "#B45309" },
  { icon: HeartHandshake, title: "Supportive Environment", sub: "Every child is unique", bg: "#FFF1E8", color: "#C2590F" },
  { icon: MapPin, title: "Richmond, BC", sub: "Local learning centre", bg: "#E6F7F8", color: "#007A85" },
];

export default function FeatureStrip() {
  return (
    <section className="bg-white border-y border-slate-200/70" data-testid="home-feature-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.title} className="flex items-center gap-3">
                <span
                  className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl"
                  style={{ backgroundColor: it.bg, color: it.color }}
                >
                  <Icon className="h-5 w-5" />
                </span>
                <div className="min-w-0">
                  <p className="text-[13px] font-extrabold font-display tracking-tight truncate" style={{ color: "#123B6D" }}>
                    {it.title}
                  </p>
                  <p className="text-[11px] text-slate-500 leading-snug truncate">{it.sub}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
